import React from 'react';
import { variants, sizes } from '../constants';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  sx?: React.CSSProperties;
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
  className?: string;
}

const Card = ({
  children,
  variant = 'outlined',
  size = 'md',
  className = '',
  sx,
  ...rest
}: CardProps) => {
  return (
    <div
      className={`rounded-lg shadow-sm transition-transform ${variants[variant]} ${sizes[size]} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Card;
